import React from 'react';

const ESimIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    className={className}
    {...props}
    width="88"
    height="88"
    viewBox="0 0 88 88"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_9094_108680)">
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H76C80.4183 0 84 3.58172 84 8V76C84 80.4183 80.4183 84 76 84H8C3.58172 84 0 80.4183 0 76V8Z"
        fill="white"
      />
      <path
        d="M8 0.5H76C80.1421 0.5 83.5 3.85786 83.5 8V76C83.5 80.1421 80.1421 83.5 76 83.5H8C3.85786 83.5 0.5 80.1421 0.5 76V8C0.5 3.85786 3.85786 0.5 8 0.5Z"
        stroke="black"
      />
    </g>
    <path
      d="M69.9999 56.5455L69.9999 38.0547C70.0068 36.607 69.427 35.2161 68.3866 34.2002L57.6981 23.6001C56.6738 22.5683 55.2713 21.9933 53.8115 22.0001L20.5 22.0001C17.4658 22.0091 15.0092 24.4455 15 27.4546L15 56.5455C15.0092 59.5546 17.4658 61.9909 20.5 62L64.4999 62C67.5341 61.9909 69.9908 59.5546 69.9999 56.5455Z"
      fill="black"
    />
    <path
      d="M28.3179 48.16C27.4325 48.16 26.6699 47.9947 26.0299 47.664C25.3899 47.3333 24.8939 46.864 24.5419 46.256C24.2005 45.648 24.0299 44.928 24.0299 44.096C24.0299 43.2853 24.1952 42.576 24.5259 41.968C24.8672 41.36 25.3312 40.8853 25.9179 40.544C26.5152 40.192 27.1925 40.016 27.9499 40.016C28.6965 40.016 29.3365 40.176 29.8699 40.496C30.4032 40.816 30.8139 41.2693 31.1019 41.856C31.4005 42.4427 31.5499 43.1413 31.5499 43.952V44.544H25.6459V43.392H30.1419L29.8859 43.632C29.8859 42.9067 29.7259 42.352 29.4059 41.968C29.0859 41.5733 28.6272 41.376 28.0299 41.376C27.5819 41.376 27.1979 41.4827 26.8779 41.696C26.5685 41.8987 26.3285 42.192 26.1579 42.576C25.9979 42.9493 25.9179 43.3973 25.9179 43.92V44.032C25.9179 44.6187 26.0085 45.104 26.1899 45.488C26.3712 45.872 26.6432 46.16 27.0059 46.352C27.3685 46.544 27.8165 46.64 28.3499 46.64C28.7872 46.64 29.2245 46.576 29.6619 46.448C30.0992 46.3093 30.4992 46.096 30.8619 45.808L31.4219 47.152C31.0485 47.4613 30.5792 47.7067 30.0139 47.888C29.4485 48.0693 28.8832 48.16 28.3179 48.16ZM37.2138 48.16C36.6271 48.16 36.0618 48.1067 35.5178 48C34.9844 47.904 34.4884 47.76 34.0298 47.568C33.5818 47.376 33.1818 47.1467 32.8298 46.88L33.4538 45.264C33.8058 45.5093 34.1738 45.7227 34.5578 45.904C34.9524 46.0747 35.3684 46.208 35.8058 46.304C36.2538 46.3893 36.7231 46.432 37.2138 46.432C38.0564 46.432 38.6698 46.2933 39.0538 46.016C39.4378 45.728 39.6298 45.36 39.6298 44.912C39.6298 44.6667 39.5711 44.4587 39.4538 44.288C39.3364 44.1067 39.1444 43.952 38.8778 43.824C38.6111 43.696 38.2591 43.5893 37.8218 43.504L36.0618 43.136C35.0484 42.9227 34.2911 42.5653 33.7898 42.064C33.2991 41.552 33.0538 40.88 33.0538 40.048C33.0538 39.344 33.2404 38.7307 33.6138 38.208C33.9871 37.6853 34.5044 37.28 35.1658 36.992C35.8271 36.704 36.5898 36.56 37.4538 36.56C37.9658 36.56 38.4564 36.6133 38.9258 36.72C39.4058 36.816 39.8431 36.9653 40.2378 37.168C40.6431 37.36 40.9951 37.5947 41.2938 37.872L40.6698 39.408C40.2218 39.0347 39.7311 38.7573 39.1978 38.576C38.6644 38.384 38.0778 38.288 37.4378 38.288C36.9471 38.288 36.5258 38.3573 36.1738 38.496C35.8218 38.6347 35.5498 38.832 35.3578 39.088C35.1764 39.3333 35.0858 39.6267 35.0858 39.968C35.0858 40.352 35.2138 40.6613 35.4698 40.896C35.7258 41.12 36.1631 41.296 36.7818 41.424L38.5258 41.792C39.5818 42.016 40.3658 42.368 40.8778 42.848C41.4004 43.328 41.6618 43.968 41.6618 44.768C41.6618 45.44 41.4804 46.032 41.1177 46.544C40.7551 47.056 40.2378 47.456 39.5658 47.744C38.9044 48.0213 38.1204 48.16 37.2138 48.16ZM43.4195 48V36.72H45.4675V48H43.4195ZM47.9515 48V36.72H49.6635L53.9195 44.576H53.4075L57.6475 36.72H59.3275V48H57.4715V39.76H57.8235L54.2395 46.288H53.0395L49.4235 39.744H49.8075V48H47.9515Z"
      fill="#02FF01"
    />
    <defs>
      <filter
        id="filter0_d_9094_108680"
        x="0"
        y="0"
        width="88"
        height="88"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9094_108680"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_9094_108680"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default ESimIcon;
